import { MutationTree } from 'vuex';
import { EAddPageMutation } from '@/dealroom/add-page/store/add-page.constants';
import { IAddPageState } from '@/dealroom/add-page/store/add-page.types';

export const mutations: MutationTree<IAddPageState> = {
  [EAddPageMutation.SetState](state: IAddPageState, newState: IAddPageState) {
    state.contentType = newState.contentType;
  },
};
